import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { environment } from '../../../environments/environment';

import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-shop-summary',
  templateUrl: './shop-summary.component.html',
  styleUrls: ['./shop-summary.component.scss'],
})
export class ShopSummaryComponent implements OnInit {
  shopSummariesListing: any = [
    {
      month: 'April',
      data: [
        {
          sub_admin: 'nabil@gmail.com',
          noOfProducts: 12,
        },
      ],
    },
    {
      month: 'March',
      data: [
        {
          sub_admin: 'nabil1122@gmail.com',
          noOfProducts: 12,
        },
      ],
    },
  ];

  formData: any = {
    email: '',
    noOfProducts: '',
    date: '',
  };
  shopSummariesData: any = [];
  selectedYear: any = '';
  selectedMonth: any = '';
  yearsList: any = [];
  selectedYearMonths: any = [];
  selectedTab: any = 0;
  isSummariesLoading: boolean = false;

  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    let currentDate = new Date();
    this.selectedYear = currentDate.getFullYear();
    this.selectedMonth = currentDate.getMonth() + 1;

    // Iterate from the current year back to 1997
    for (let year = this.selectedYear; year >= 1997; year--) {
      // Convert the year to a string and push it to the array
      this.yearsList.push(year.toString());
    }

    this.getMonthsOfYear();
    this.readShopSummaries();
  }

  openNewSummaryModal(content) {
    this.modalService.open(content, { size: 'sm' });
  }

  addNewSummary() {
    // console.log('form data=====>', this.formData);
    // const dateString = this.formData.date;
    // const parts = dateString.split('-');
    // this.formData = {
    //   ...this.formData,
    //   year: parts[0],
    //   month: parts[1],
    //   day: parts[2],
    // };
    // delete this.formData.date;
    // this.auth.save_shop_summary(this.formData).subscribe(
    //   (response: any) => {
    //     this.toastr.success(response.message);
    //     this.modalService.dismissAll();
    //     // let monthWithoutZero = parseInt(numWithZero, 10);
    //     console.log(
    //       'called ======>',
    //       this.selectedMonth,
    //       parts[1],
    //       this.selectedYear,
    //       parts[0]
    //     );
    //     if (this.selectedMonth == parts[1] && this.selectedYear == parts[0]) {
    //       console.log('called===============> in if condition');
    //       this.readShopSummaries();
    //     }
    //   },
    //   (e) => {
    //     if (e.status == 400) {
    //       this.toastr.error(e.error.message);
    //     }
    //   }
    // );
  }
  onYearChange(event) {
    console.log('event======>', event);
    this.selectedYear = event.target.value;
    this.selectedTab = 0;
    this.getMonthsOfYear();
    this.readShopSummaries();
  }
  readShopSummaries() {
    this.isSummariesLoading = true;
    this.shopSummariesData = [];
    this.auth
      .read_shop_summaries({
        year: this.selectedYear,
        month: this.selectedMonth,
      })
      .subscribe(
        (response: any) => {
          this.shopSummariesData = response.body;
          this.isSummariesLoading = false;
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
          this.isSummariesLoading = false;
        }
      );
  }

  getMonthsOfYear() {
    let currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    let currentMonth = currentDate.getMonth();
    let months = [
      { name: 'January', number: 1 },
      { name: 'February', number: 2 },
      { name: 'March', number: 3 },
      { name: 'April', number: 4 },
      { name: 'May', number: 5 },
      { name: 'June', number: 6 },
      { name: 'July', number: 7 },
      { name: 'August', number: 8 },
      { name: 'September', number: 9 },
      { name: 'October', number: 10 },
      { name: 'November', number: 11 },
      { name: 'December', number: 12 },
    ];

    if (this.selectedYear == currentYear) {
      this.selectedYearMonths = months.slice(0, currentMonth + 1).reverse();
    } else {
      this.selectedYearMonths = months;
    }

    this.selectedMonth = this.selectedYearMonths[0].number;
  }
  onMonthSelectionChanged(month) {
    if (month.number == this.selectedMonth) {
      return;
    }
    this.selectedMonth = month.number;
    this.readShopSummaries();
    console.log('tab selection changed');
  }
}
